import * as React from 'react';
export const postbankSvg = React.forwardRef(function postbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFCC01',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#010166',
          d: 'M27.554 15.393a11.97 11.97 0 0 0-5.14 7.88h-2.47c.42-2.59 2.02-6.08 4.35-7.83l3.26-.05zm-4.31-6.92a23.16 23.16 0 0 0-10.62 16.25h-8.23c.6-4.72 4.4-12.94 9.28-16l9.57-.24z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: 'red',
          d: 'M25.804 12.973a15.04 15.04 0 0 0-7.29 10.8h-4.27c.36-2.67 2.13-7.7 5.96-10.64l5.6-.16z',
        }),
      ),
    ),
  );
});
postbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var postbank = {
  category: 'brand',
  colorable: false,
  name: 'postbank',
  svg: postbankSvg,
};
